import React from 'react';
import Module from './Module';

export default props => {
  const { inViewport, forwardedRef } = props;
  return (
    <Module type="image">
      {props.image &&
        <img src={props.image.url} />
      }
      <div className="overlay">
        <div className="inner">
          {props.preline &&
            <div className="preline" dangerouslySetInnerHTML={{__html: props.preline}} />
          }

          {props.headline &&
            <div className="headline">
              {props.headline}
            </div>
          }

          {props.subline &&
            <div className="subline" dangerouslySetInnerHTML={{__html: props.subline}} />
          }

          {props.credits &&
            <div className="credits" dangerouslySetInnerHTML={{__html: props.credits}} />
          }
        </div>
      </div>
    </Module>
  )
};
